// Commodity metadata + display formatters (mirrors backend/commodity_meta.py)
// `plotMax` is the sensible upper bound for colorbars/histograms so Fe (0-70%)
// doesn't crush Au (0-10 g/t) or Li (0-8000 ppm) into a single colour band.

export const COMMODITIES = [
  // Bulk & iron
  { code: "Fe",  name: "Iron",         gradeUnit: "pct", gradeSymbol: "%",   productUnit: "t", priceBasis: "t",  defaultCutoff: 45,   plotMax: 70,    typicalPrice: 110,   category: "bulk"     },
  { code: "Mn",  name: "Manganese",    gradeUnit: "pct", gradeSymbol: "%",   productUnit: "t", priceBasis: "t",  defaultCutoff: 15,   plotMax: 55,    typicalPrice: 180,   category: "bulk"     },
  { code: "Cr",  name: "Chromite",     gradeUnit: "pct", gradeSymbol: "%",   productUnit: "t", priceBasis: "t",  defaultCutoff: 30,   plotMax: 55,    typicalPrice: 280,   category: "bulk"     },
  { code: "Al",  name: "Aluminium",    gradeUnit: "pct", gradeSymbol: "%",   productUnit: "t", priceBasis: "t",  defaultCutoff: 40,   plotMax: 60,    typicalPrice: 80,    category: "bulk"     },
  { code: "Ba",  name: "Barite",       gradeUnit: "pct", gradeSymbol: "%",   productUnit: "t", priceBasis: "t",  defaultCutoff: 90,   plotMax: 100,   typicalPrice: 90,    category: "bulk"     },
  { code: "K",   name: "Potash",       gradeUnit: "pct", gradeSymbol: "%",   productUnit: "t", priceBasis: "t",  defaultCutoff: 15,   plotMax: 35,    typicalPrice: 350,   category: "bulk"     },
  // Base
  { code: "Cu",  name: "Copper",       gradeUnit: "pct", gradeSymbol: "%",   productUnit: "t", priceBasis: "t",  defaultCutoff: 0.30, plotMax: 3,     typicalPrice: 9500,  category: "base"     },
  { code: "Pb",  name: "Lead",         gradeUnit: "pct", gradeSymbol: "%",   productUnit: "t", priceBasis: "t",  defaultCutoff: 1.00, plotMax: 8,     typicalPrice: 2200,  category: "base"     },
  { code: "Zn",  name: "Zinc",         gradeUnit: "pct", gradeSymbol: "%",   productUnit: "t", priceBasis: "t",  defaultCutoff: 2.00, plotMax: 15,    typicalPrice: 2900,  category: "base"     },
  { code: "Ni",  name: "Nickel",       gradeUnit: "pct", gradeSymbol: "%",   productUnit: "t", priceBasis: "t",  defaultCutoff: 0.40, plotMax: 3,     typicalPrice: 17000, category: "base"     },
  { code: "Co",  name: "Cobalt",       gradeUnit: "pct", gradeSymbol: "%",   productUnit: "t", priceBasis: "t",  defaultCutoff: 0.05, plotMax: 0.5,   typicalPrice: 30000, category: "base"     },
  { code: "Sn",  name: "Tin",          gradeUnit: "pct", gradeSymbol: "%",   productUnit: "t", priceBasis: "t",  defaultCutoff: 0.20, plotMax: 2,     typicalPrice: 27000, category: "base"     },
  { code: "W",   name: "Tungsten",     gradeUnit: "pct", gradeSymbol: "%",   productUnit: "t", priceBasis: "t",  defaultCutoff: 0.15, plotMax: 1.5,   typicalPrice: 32000, category: "base"     },
  { code: "Mo",  name: "Molybdenum",   gradeUnit: "pct", gradeSymbol: "%",   productUnit: "t", priceBasis: "t",  defaultCutoff: 0.02, plotMax: 0.2,   typicalPrice: 40000, category: "base"     },
  // Precious
  { code: "Au",  name: "Gold",         gradeUnit: "g_t", gradeSymbol: "g/t", productUnit: "g", priceBasis: "oz", defaultCutoff: 0.50, plotMax: 10,    typicalPrice: 2300,  category: "precious" },
  { code: "Ag",  name: "Silver",       gradeUnit: "g_t", gradeSymbol: "g/t", productUnit: "g", priceBasis: "oz", defaultCutoff: 30,   plotMax: 500,   typicalPrice: 28,    category: "precious" },
  { code: "Pt",  name: "Platinum",     gradeUnit: "g_t", gradeSymbol: "g/t", productUnit: "g", priceBasis: "oz", defaultCutoff: 1.00, plotMax: 15,    typicalPrice: 1000,  category: "precious" },
  { code: "Pd",  name: "Palladium",    gradeUnit: "g_t", gradeSymbol: "g/t", productUnit: "g", priceBasis: "oz", defaultCutoff: 1.00, plotMax: 15,    typicalPrice: 1000,  category: "precious" },
  // Trace / radiometric
  { code: "U3O8",name: "Uranium",      gradeUnit: "ppm", gradeSymbol: "ppm", productUnit: "t", priceBasis: "lb", defaultCutoff: 200,  plotMax: 3000,  typicalPrice: 80,    category: "trace"    },
  { code: "Li",  name: "Lithium",      gradeUnit: "ppm", gradeSymbol: "ppm", productUnit: "t", priceBasis: "t",  defaultCutoff: 400,  plotMax: 8000,  typicalPrice: 15000, category: "trace"    },
  { code: "REE", name: "Rare Earths",  gradeUnit: "ppm", gradeSymbol: "ppm", productUnit: "t", priceBasis: "kg", defaultCutoff: 1000, plotMax: 20000, typicalPrice: 80,    category: "trace"    },
  { code: "Nb",  name: "Niobium",      gradeUnit: "ppm", gradeSymbol: "ppm", productUnit: "t", priceBasis: "kg", defaultCutoff: 200,  plotMax: 5000,  typicalPrice: 45,    category: "trace"    },
  { code: "Ta",  name: "Tantalum",     gradeUnit: "ppm", gradeSymbol: "ppm", productUnit: "t", priceBasis: "kg", defaultCutoff: 100,  plotMax: 2000,  typicalPrice: 250,   category: "trace"    },
  { code: "Dia", name: "Diamond",      gradeUnit: "g_t", gradeSymbol: "cpht", productUnit: "g", priceBasis: "ct", defaultCutoff: 0.5, plotMax: 5,     typicalPrice: 150,   category: "trace"    },
];

export const CATEGORY_LABELS = {
  bulk:     "Bulk & Iron",
  base:     "Base Metals",
  precious: "Precious Metals",
  trace:    "Trace / Radiometric",
};

/** Returns COMMODITIES grouped by `category` for use in <optgroup> pickers. */
export function commoditiesByCategory() {
  const groups = {};
  for (const c of COMMODITIES) {
    (groups[c.category] ||= []).push(c);
  }
  return Object.entries(groups).map(([cat, items]) => ({
    category: cat,
    label: CATEGORY_LABELS[cat] || cat,
    items,
  }));
}

/** Sensible upper bound for colour scales, sliders and histograms — commodity-aware. */
export function getPlotMax(code) {
  return getCommodity(code)?.plotMax ?? 100;
}

export const DEFAULT_COMMODITY = COMMODITIES[0];

export function getCommodity(code) {
  return COMMODITIES.find((c) => c.code === code) || DEFAULT_COMMODITY;
}

const GRAM_PER_TONNE = 1_000_000;
const GRAM_PER_OZ_TROY = 31.1034768;

/** Convert a raw grade to the ratio (0..1) that maps mass-of-metal per mass-of-ore. */
export function gradeToFraction(grade, gradeUnit) {
  if (gradeUnit === "pct") return grade / 100;
  if (gradeUnit === "g_t" || gradeUnit === "ppm") return grade / GRAM_PER_TONNE;
  return grade;
}

/** Format ore tonnage — always metric tonnes but scaled to kt/Mt for readability. */
export function formatOre(tonnes, opts = {}) {
  if (tonnes == null || Number.isNaN(tonnes)) return "—";
  const abs = Math.abs(tonnes);
  const sign = tonnes < 0 ? "-" : "";
  if (abs >= 1e6) return `${sign}${(abs / 1e6).toLocaleString(undefined, { maximumFractionDigits: 2 })} Mt`;
  if (abs >= 1e3) return `${sign}${(abs / 1e3).toLocaleString(undefined, { maximumFractionDigits: 2 })} kt`;
  return `${sign}${abs.toLocaleString(undefined, { maximumFractionDigits: 2 })} t`;
}

/** Format the contained metal — commodity-aware. Base metals in Mt/kt/t;
 *  precious in kg/oz/t depending on magnitude. `tonnes_metal` is metric
 *  tonnes of contained metal (the backend stores everything in tonnes).
 */
export function formatMetal(tonnesMetal, commodityCode, opts = {}) {
  if (tonnesMetal == null || Number.isNaN(tonnesMetal)) return "—";
  const c = getCommodity(commodityCode);
  const abs = Math.abs(tonnesMetal);
  const sign = tonnesMetal < 0 ? "-" : "";
  const asOz = opts.asOz || (c.priceBasis === "oz");
  if (c.category === "precious") {
    // Prefer troy ounces, fall back to kg
    if (asOz) {
      const oz = tonnesMetal * GRAM_PER_TONNE / GRAM_PER_OZ_TROY;
      const absOz = Math.abs(oz);
      if (absOz >= 1e6) return `${sign}${(absOz / 1e6).toLocaleString(undefined, { maximumFractionDigits: 2 })} Moz`;
      if (absOz >= 1e3) return `${sign}${(absOz / 1e3).toLocaleString(undefined, { maximumFractionDigits: 2 })} koz`;
      return `${sign}${absOz.toLocaleString(undefined, { maximumFractionDigits: 0 })} oz`;
    }
    // kg
    const kg = abs * 1000;
    if (kg >= 1e6) return `${sign}${(kg / 1e3).toLocaleString(undefined, { maximumFractionDigits: 1 })} t`;
    if (kg >= 1e3) return `${sign}${(kg / 1e3).toLocaleString(undefined, { maximumFractionDigits: 2 })} t`;
    return `${sign}${kg.toLocaleString(undefined, { maximumFractionDigits: 1 })} kg`;
  }
  if (c.category === "trace") {
    // Prefer kg for REE/Nb/Ta, tonnes for others
    if (c.priceBasis === "kg") {
      const kg = abs * 1000;
      if (kg >= 1e6) return `${sign}${(kg / 1e6).toLocaleString(undefined, { maximumFractionDigits: 2 })} kt`;
      if (kg >= 1e3) return `${sign}${(kg / 1e3).toLocaleString(undefined, { maximumFractionDigits: 2 })} t`;
      return `${sign}${kg.toLocaleString(undefined, { maximumFractionDigits: 0 })} kg`;
    }
    if (c.priceBasis === "lb") {
      const lb = abs * (GRAM_PER_TONNE / 453.59237);
      if (lb >= 1e6) return `${sign}${(lb / 1e6).toLocaleString(undefined, { maximumFractionDigits: 2 })} Mlb`;
      return `${sign}${(lb / 1e3).toLocaleString(undefined, { maximumFractionDigits: 1 })} klb`;
    }
    return formatOre(tonnesMetal);
  }
  // Bulk / base
  return formatOre(tonnesMetal);
}

/** Format a grade value with the commodity's native symbol. */
export function formatGrade(grade, commodityCode, opts = {}) {
  if (grade == null || Number.isNaN(grade)) return "—";
  const c = getCommodity(commodityCode);
  const digits = opts.digits ?? (c.gradeUnit === "pct" ? 2 : c.gradeUnit === "g_t" ? 2 : 0);
  return `${Number(grade).toLocaleString(undefined, { maximumFractionDigits: digits })} ${c.gradeSymbol}`;
}
